import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

@Component
/**
 * ContactInfo Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Content of contact info
     */
    @Prop() content!: object;

    /**
     * Remove titles of contact info
     */
    @Prop({ default: false }) noTitle!: boolean;

    /**
     * Remove icon of contact info
     */
    @Prop({ default: false }) noIcon!: boolean;

    /**
     * Remove anchor
     */
    @Prop({ default: false }) noLink!: boolean;

    /**
     * Icon color
     */
    @Prop({ default: 'body' }) iconColor!: string;

    /**
     * Icon color
     */
    @Prop({ default: 'large' }) iconSize!: string;

    /**
     * Branch number
     */
    @Prop({ type: [String, Number], default: 1 }) branch!: number | string;

    /**
     * Excludes item for show
     */
    @Prop() exclude!: Array<string>;

    /**
     * Marge title and content in one line
     */
    @Prop({ default: false }) oneLine!: boolean;
}
